export default requester => {
    return {
        /**
         * Get idea feedback
         *
         * @param {sting} id
         * @returns
         */
        feedback(id) {
            return requester.get(`/ideas/${id}/feedbacks`)
        },

        /**
         * Create new idea
         *
         * @param {object} data
         * @returns
         */
        create(data = {}) {
            return requester.post('/ideas/v2', data)
        },

        /**
         * Decline idea
         **/
        decline(id) {
            return requester.post(`/ideas/${id}/decline`)
        },

        /**
         * Get idea contents
         *
         * @param {string} challengeSlug
         * @param {string} ideaId
         * @returns {object}
         **/
        content(challengeSlug, ideaId) {
            return requester.get(`/challenges/${challengeSlug}/ideas/${ideaId}/contents`).then(({ data }) => {
                const { data: content } = data;
                return {
                    data: {
                        data: {
                            ...content.idea,
                            stats: content.stats,
                            user_stats: content.user_stats,
                        }
                    }
                };
            });
        },
    };
}


